// extracted by mini-css-extract-plugin
module.exports = {"background":"Featured_background__KjpMp","mobileMedia":"Featured_mobileMedia__zhdR_"};